import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** PATCH `/ims/stock-return/{id}/remark`。任何狀態可用；不改 issueReason。 */
export async function updateStockReturnRemark(id, payload) {
  const { data: raw } = await request.patch(
    `/ims/stock-return/${id}/remark`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
